document.addEventListener('DOMContentLoaded', () => {
  const links = document.querySelectorAll('.out_menubox li');

  // 点击标题，页面缓动滚动到对应模块
  links.forEach(function (link) {
    link.addEventListener('click', function (event) {
      event.preventDefault();
      const aLink = this.querySelector('a');
      const targetId = aLink.getAttribute('href');
      const targetElement = document.querySelector(`${targetId}`);

      targetElement.scrollIntoView({
        behavior: 'smooth'
      });
    });
  });

  // 标题高亮
  // $('.out_menubox li').click(function() {
  //   $('.out_menubox li').removeClass('active')
  //   $(this).addClass('active')
  // })

  const navLinks = $(".out_menubox li");
  const sections = $(".support-content-box .support-block");

  navLinks.each(function (index) {
    $(this).attr('data-target', 'module' + index)
  })

  sections.each(function (index) {
    $(this).attr('data-target', 'module' + index)
  })

  // 页面滚动时标题置顶位置改变
  window.addEventListener('scroll', function () {

    let scrollPosition = $(this).scrollTop();
    let found = false; // 点击后只需要高亮被点击的导航
    sections.each(function () {
      if (found) return;

      const sectionTop = $(this).offset().top;
      const sectionHeight = $(this).outerHeight();
      const sectionTarget = $(this).attr("data-target");
      // 检查当前滚动位置是否在模块的范围内
      if (scrollPosition >= sectionTop - 16 && scrollPosition < sectionTop + sectionHeight - 2) {
        navLinks.removeClass("active");
        $(`.out_menubox li[data-target="${sectionTarget}"]`).addClass("active");
        found = true;
      }
    });


  });

  function getScrollDirection() {
    let scrollDirection = '';

    if (window.scrollY > this.previousScroll) {
      scrollDirection = 'down';
    } else {
      scrollDirection = 'up';
    }

    this.previousScroll = window.scrollY;
    return scrollDirection;
  }

  if (window.innerWidth < 990) {
    $('.slider_nav_box').css('top', '0')
  }

});


// aftership 插件
(function (e, t, n) { var r, i = e.getElementsByTagName(t)[0]; if (e.getElementById(n)) return; r = e.createElement(t); r.id = n; r.src = "//button.aftership.com/all.js"; i.parentNode.insertBefore(r, i) })(document, "script", "aftership-jssdk")